import script from "./LangMixins.vue?vue&type=script&lang=ts"
export * from "./LangMixins.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__